import { render } from "./MobileAppNotice.vue?vue&type=template&id=73e62211&scoped=true"
import script from "./MobileAppNotice.vue?vue&type=script&lang=js"
export * from "./MobileAppNotice.vue?vue&type=script&lang=js"

import "./MobileAppNotice.vue?vue&type=style&index=0&id=73e62211&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e62211"]])

export default __exports__